import { render, staticRenderFns } from "./VideoScrollMobile.vue?vue&type=template&id=5f49ca6e&"
import script from "./VideoScrollMobile.vue?vue&type=script&lang=js&"
export * from "./VideoScrollMobile.vue?vue&type=script&lang=js&"
import style0 from "./VideoScrollMobile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports